import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import {
  NzBreadCrumbComponent,
  NzBreadCrumbItemComponent,
} from 'ng-zorro-antd/breadcrumb';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-drawer-header',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    NzBreadCrumbComponent,
    NzBreadCrumbItemComponent,
    SvgIconComponent,
  ],
  template: `
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon [src]="backButtonIcon" class="icon s-20"></svg-icon>
        </button>
      </div>
      <div>
        <h3 class="ant-drawer-title">{{ title }}</h3>
        <nz-breadcrumb nzSeparator=">" *ngIf="subtitle && breadcrumbText">
          <nz-breadcrumb-item>
            <span>{{ breadcrumbText }}</span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="handleClose()"
            (keydown.enter)="handleClose()">
            <a tabindex="0">{{ subtitle }}</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  `,
  styles: [
    `
      .drawer-title-wrapper {
        display: flex;
        align-items: flex-start;
        gap: 16px;

        .back-button {
          button {
            padding: 8px;
            height: auto;
          }
        }
      }
    `,
  ],
})
export class DrawerHeaderComponent {
  @Input() title = '';
  @Input() breadcrumbText = '';
  @Input() backButtonIcon = '/assets/icon/icon-arrow.svg';
  @Input() subtitle = '';
  @Output() close = new EventEmitter<void>();

  handleClose(): void {
    this.close.emit();
  }
}
